import { MailOtpSource } from '@monorepo/types';
import { getEnv } from '@hub/helpers/getters.store';

export class MailOtpStore {
  async getMailOtpStatus(sourceId: string) {
    const {
      apiFactory: { mailOtpService },
    } = getEnv();

    return await mailOtpService.getMailOtpStatus(sourceId);
  }

  async sendMail(
    source: MailOtpSource,
    sourceId: string,
    displayName?: string,
  ) {
    const {
      apiFactory: { mailOtpService },
    } = getEnv();

    return await mailOtpService.sendMail(source, sourceId, displayName);
  }

  async verifyMailOtp(sourceId: string, code: string) {
    const {
      apiFactory: { mailOtpService },
    } = getEnv();

    return await mailOtpService.verifyMailOtp(sourceId, code);
  }
}
